export default "__VITE_ASSET__BKdMv5Hw__"